import { createContext } from 'react';

export const FarmPoolContext = createContext({});